import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

/**
 * Показывает уведомление, формируя HTML-строку вместо DOM-узла.
 * @param {object} options - Параметры уведомления.
 * @param {string} options.title - Заголовок (необязательно).
 * @param {string} options.text - Простой текст (используется, если нет html).
 * @param {string} options.html - HTML-содержимое.
 * @param {string} options.background - Цвет фона.
 * @param {number} options.timeout - Длительность показа в мс.
 */
function showToast({ title = '', text = '', html = '', background = "#3498db", timeout = 3000 }) {
    // Формируем HTML как строку
    let toastHTML = '';

    if (title) {
        // Добавляем заголовок, если он есть
        toastHTML += `<div style="font-weight: bold; margin-bottom: 5px;">${title}</div>`;
    }

    // Добавляем основное содержимое
    // Свойство `html` имеет приоритет над `text`
    toastHTML += `${html || text}`;

    Toastify({
        text: toastHTML, // Передаем нашу HTML-строку
        duration: timeout,
        gravity: "bottom",
        position: "right",
        close: true,
        backgroundColor: background,
        escapeMarkup: false,
    }).showToast();
}

export const notify = {
    success(arg = {}) { const o = typeof arg === 'string' ? { text: arg } : arg; showToast({ ...o, background: o.background || "#28c76f" }); },
    error  (arg = {}) { const o = typeof arg === 'string' ? { text: arg } : arg; showToast({ ...o, background: o.background || "#ea5455" }); },
    info   (arg = {}) { const o = typeof arg === 'string' ? { text: arg } : arg; showToast({ ...o, background: o.background || "#3498db" }); },
    warning(arg = {}) { const o = typeof arg === 'string' ? { text: arg } : arg; showToast({ ...o, background: o.background || "#ff9f43" }); },
    raw    (opts = {}) { showToast(opts); },
};

export default {
    install(app) {
        app.config.globalProperties.$notify = notify;
    },
};
